const tagrules = {
    "boolean": 'match (boolean)',
    "in": 'is in these [values]',
    "is": 'is (=)',
    "isnot": 'is not (=/=)',
    "not in": 'is not in these [values]',
    "not contains": 'does not contain',
};
export default tagrules;